import { render, staticRenderFns } from "./PanelistSurveyVoteEditorDr.vue?vue&type=template&id=20c09353"
import script from "./PanelistSurveyVoteEditorDr.vue?vue&type=script&lang=ts"
export * from "./PanelistSurveyVoteEditorDr.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports